import { Slider } from "../../../components";
import { ProposalForReplacement } from "../prints";
import { ESTIMATION_TERMS, formatCustomerAddress } from "./estimation";
import { ICONS } from "../../../components";

export const PrintEstimateSlider = ({ open, onAfterOpen, ticket, total }) => (
  <Slider
    title={ICONS.VIEW}
    open={open}
    onAfterOpen={onAfterOpen}
    header={
      <>
        <span className="me-3">{ICONS.VIEW}</span>
        <span>Estimation</span>
      </>
    }
  >
    <ProposalForReplacement
      ticket={ticket}
      company_name={ticket.customer.company_name}
      company_address={`${ticket.organization.address}, ${ticket.organization.city} - ${ticket.organization.pin_code}`}
      company_phone={ticket.organization.contact_number}
      recipient_company={ticket.customer.company_name}
      recipient_address={formatCustomerAddress(ticket.customer)}
      date={new Date().toLocaleDateString("en-IN", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })}
      attention_person={`${ticket.customer.first_name} ${ticket.customer.last_name}`}
      subject="Proposal for Parts Replacement"
      reference_no={ticket.reference_number}
      serial_no={ticket.device.serial_number}
      device_details={ticket.device.configuration}
      issue={ticket.issue_reported_by_customer}
      parts={ticket.quotation_records}
      total_cost={total}
      terms={ESTIMATION_TERMS}
      from_name={ticket.created_by}
      from_company={ticket.organization.name}
    />
  </Slider>
);
